import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { aiMonitoringAPI } from '../../services';

/** Ảnh mẫu của màn So sánh mô hình (tải kèm JWT) + viền đỏ VÙNG SẾP KHOANH (đa giác `points`, không có thì `box`). */
const VisionBenchSampleImage = ({ id, box, points }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let url = null;
    let alive = true;
    aiMonitoringAPI
      .benchSampleImage(id)
      .then((blob) => {
        if (!alive) return;
        url = URL.createObjectURL(blob);
        setSrc(url);
      })
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [id]);
  if (failed) return <span className="cambill-img-empty">Không tải được ảnh</span>;
  if (!src)
    return (
      <Spinner
        size="sm"
        animation="border"
        variant="light"
      />
    );
  return (
    <a
      href={src}
      target="_blank"
      rel="noreferrer"
      className="cambill-img-wrap"
      title="Mở ảnh lớn"
    >
      <img
        src={src}
        alt="Ảnh mẫu"
        loading="lazy"
      />
      {Array.isArray(points) && points.length >= 3 ? (
        <svg
          viewBox="0 0 1 1"
          preserveAspectRatio="none"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
        >
          <polygon
            points={points.map((p) => `${p[0]},${p[1]}`).join(' ')}
            fill="none"
            stroke="#ff2d2d"
            strokeWidth={2}
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      ) : (
        box && (
          <span
            className="cambill-box"
            style={{
              left: `${box.x * 100}%`,
              top: `${box.y * 100}%`,
              width: `${box.w * 100}%`,
              height: `${box.h * 100}%`,
            }}
          />
        )
      )}
    </a>
  );
};

export default VisionBenchSampleImage;
